/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';

import FederatedMFE, { LoaderType } from 'common/components/FederatedMFE';
import { injectReducerAsync } from 'app/reduxStore';

import './NewAndUpdated.scss';

const NewAndUpdated: React.FC<{
  newContent: number;
  updatedContent: number;
  projectId: string;
  shouldRetrieveNotificationCount: boolean;
}> = ({
  newContent,
  updatedContent,
  projectId,
  shouldRetrieveNotificationCount,
}) => (
  <div className="new-and-updated-container">
    <FederatedMFE
      urlKey="REACT_APP_NOTIFICATIONS_COUNTS_MFE_URL"
      scope="notificationsCounts"
      componentModule="./NotificationsCounts"
      injectionReducerCb={injectReducerAsync}
      props={{
        projectId,
        shouldRetrieveNotificationCount,
      }}
      loader={LoaderType.Circular}
    />
    <FederatedMFE
      urlKey="REACT_APP_NOTIFICATIONS_COUNT_LINK_MFE_URL"
      scope="notificationsCountLink"
      componentModule="./NotificationsCountLink"
      injectionReducerCb={injectReducerAsync}
      props={{
        text: 'New Content',
        to: shouldRetrieveNotificationCount
          ? `/projects/${projectId}/notifications/project-activity`
          : '/projects',
        count: newContent,
      }}
      loader={LoaderType.Circular}
    />
    <FederatedMFE
      urlKey="REACT_APP_NOTIFICATIONS_COUNT_LINK_MFE_URL"
      scope="notificationsCountLink"
      componentModule="./NotificationsCountLink"
      injectionReducerCb={injectReducerAsync}
      props={{
        text: 'Updated Content',
        to: shouldRetrieveNotificationCount
          ? `/projects/${projectId}/notifications/project-activity`
          : '/projects',
        count: updatedContent,
      }}
      loader={LoaderType.Circular}
    />
  </div>
);

export default NewAndUpdated;
